@if (showLdr) {
<ds-loading></ds-loading>
}
<nz-drawer
  [nzWidth]="'60%'"
  [nzClosable]="true"
  [nzVisible]="visibleVhclSldr"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visibleVhclSldr = false"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Add New Vehicle / Add New Device drawers (shared with the Add Vehicle page) -->
<app-add-vehicle-device
  #vhclFrms
  [clntId]="clntId"
  [tntId]="selectedtenant"
  (saved)="onVhclSaved()"
></app-add-vehicle-device>

<!-- Brand Header -->
<div
  class="relative mb-2 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div class="flex items-center justify-between px-5 py-3 relative">
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Vehicle Management
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center" style="gap: 8px">
      @if (fromUrbanDashboard) {
      <button
        (click)="goBackToDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
      } @if (USER_PERMISSIONS.insrt_in == 1) {
      <button
        (click)="openAddDevice()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: #fff;
          color: #0f766e;
          border: 1px solid #0f766e;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.15);
        "
      >
        <span nz-icon nzType="plus" nzTheme="outline"></span>
        Add New Device
      </button>
      } @if (USER_PERMISSIONS.insrt_in == 1) {
      <button
        (click)="openAddVehicle()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(229, 62, 62, 0.3);
        "
      >
        <span nz-icon nzType="plus" nzTheme="outline"></span>
        Add New Vehicle
      </button>
      } @if (filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: linear-gradient(135deg, #0f766e, #115e59);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Hide Filters
      </button>
      } @if (!filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Show Filters
      </button>
      }
    </div>
  </div>
</div>

<div class="mx-auto px-3">
  <!-- Filter Strip -->
  <div
    class="ams-filter-strip"
    [class.ams-filter-strip--open]="filterPanelOpen"
  >
    <div class="ams-filter-inner" [class.hidden]="!filterPanelOpen">
      <div class="ams-filter-grid">
        <!-- ULB Dropdown -->
        @if (tntLst.length>1) {
        <div class="ams-filter-field">
          <label class="ams-filter-label">{{ hdrLbl }}</label>
          <nz-select
            class="w-full"
            nzShowSearch
            nzPlaceHolder="Select ULB"
            [ngModel]="selectedtenant ?? 0"
            (ngModelChange)="onFilterULBChange($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
            @for (t of tntLst; track t) {
            <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
            }
          </nz-select>
        </div>
        } @if (tntLst && tntLst.length==1) {
        <div class="ams-filter-field ams-filter-static">
          <label class="ams-filter-label">{{ hdrLbl }}</label>
          <span class="ams-filter-value">{{ tntLst[0].tnt_nm }}</span>
        </div>
        }
        <!-- Vehicle Category Dropdown -->
        <div class="ams-filter-field">
          <label class="ams-filter-label">Vehicle Category</label>
          <nz-select
            class="w-full"
            nzShowSearch
            nzPlaceHolder="Select Category"
            [ngModel]="selectedctgry ?? 0"
            (ngModelChange)="onFilterCategoryChange($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            @for (chip of categoryFilterOptions; track chip) {
            <nz-option
              [nzValue]="chip.asrt_ctgry_id"
              [nzLabel]="chip.asrt_ctgry_nm + ' (' + (chip.ct || 0) + ')'"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories & Status Section -->
  <div class="flex flex-col gap-1.5 mb-1.5">
    <!-- Categories Strip -->
    <div
      class="flex items-center gap-2 bg-white rounded-lg border border-gray-200 px-3 py-1.5 shadow-sm"
    >
      <div class="flex items-center gap-1.5 shrink-0">
        <div class="w-1.5 h-4 rounded-full bg-teal-600"></div>
        <span
          class="text-[11px] font-bold uppercase tracking-wide text-gray-700"
          >Categories</span
        >
      </div>
      <div class="flex items-center gap-1 flex-1 min-w-0">
        <button
          type="button"
          (click)="scrollCategories('left')"
          class="shrink-0 w-6 h-6 flex items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-400 hover:bg-teal-600 hover:text-white hover:border-teal-600 transition-all"
          [disabled]="!canScrollLeft"
          [class.opacity-30]="!canScrollLeft"
          [class.cursor-not-allowed]="!canScrollLeft"
        >
          <i
            nz-icon
            nzType="left"
            nzTheme="outline"
            style="font-size: 11px"
          ></i>
        </button>
        <div class="flex-1 overflow-hidden">
          <div class="ams-category-scroll" #categoryStrip>
            @for (chip of categoryChips; track trackByChipId($index, chip)) {
            <button
              class="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border transition-all cursor-pointer select-none"
              [ngClass]="
                isCategoryActive(chip)
                  ? 'bg-teal-600 text-white border-teal-600 shadow-md shadow-teal-200'
                  : 'bg-white text-gray-600 border-gray-200 hover:bg-teal-50 hover:border-teal-300 hover:text-teal-700'
              "
              (click)="handleCategoryChipSelect(chip, $event)"
              [disabled]="false"
              type="button"
            >
              <span>{{ chip.asrt_ctgry_nm }}</span>
              <span
                class="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold"
                [ngClass]="
                  isCategoryActive(chip)
                    ? 'bg-white/20 text-white'
                    : 'bg-gray-100 text-gray-500'
                "
                >{{ chip.ct || 0 }}</span
              >
            </button>
            }
          </div>
        </div>
        <button
          type="button"
          (click)="scrollCategories('right')"
          class="shrink-0 w-6 h-6 flex items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-400 hover:bg-teal-600 hover:text-white hover:border-teal-600 transition-all"
          [disabled]="!canScrollRight"
          [class.opacity-30]="!canScrollRight"
          [class.cursor-not-allowed]="!canScrollRight"
        >
          <i
            nz-icon
            nzType="right"
            nzTheme="outline"
            style="font-size: 11px"
          ></i>
        </button>
      </div>
    </div>

    <!-- Status + Parking Row -->
    <div class="ams-tw-row grid gap-1.5 items-stretch">
      <!-- Vehicle Status -->
      <div
        class="bg-white rounded-lg border border-gray-200 px-3 py-2.5 shadow-sm flex flex-col"
      >
        <div class="flex items-center gap-1.5 mb-2">
          <div class="w-2 h-2 rounded-full bg-blue-600"></div>
          <span
            class="text-[11px] font-bold uppercase tracking-wide text-gray-700"
            >Status</span
          >
        </div>
        <div class="flex flex-wrap gap-1.5 flex-1 content-start">
          @for (c of cardcntSummary; track c; let i = $index) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-full pl-2 pr-1 py-[3px] text-[11px] font-medium bg-white border border-gray-200 shadow-sm transition-all cursor-pointer hover:shadow hover:-translate-y-px"
            [ngClass]="
              c.crdChnge
                ? 'ring-2 ring-teal-500 ring-offset-1 shadow-md border-teal-400'
                : ''
            "
            (click)="cardchnge(c.asrt_sts_id)"
          >
            <span
              class="w-1.5 h-1.5 rounded-full shrink-0"
              [ngClass]="
                i % 6 === 0
                  ? 'bg-teal-500'
                  : i % 6 === 1
                  ? 'bg-gray-400'
                  : i % 6 === 2
                  ? 'bg-blue-500'
                  : i % 6 === 3
                  ? 'bg-red-500'
                  : i % 6 === 4
                  ? 'bg-amber-500'
                  : 'bg-violet-500'
              "
            ></span>
            <span class="text-gray-700 whitespace-nowrap">{{
              c.asrt_sts_nm
            }}</span>
            <span
              class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold text-white"
              [ngClass]="
                i % 6 === 0
                  ? 'bg-teal-500'
                  : i % 6 === 1
                  ? 'bg-gray-500'
                  : i % 6 === 2
                  ? 'bg-blue-500'
                  : i % 6 === 3
                  ? 'bg-red-500'
                  : i % 6 === 4
                  ? 'bg-amber-500'
                  : 'bg-violet-500'
              "
              >{{ c.ct }}</span
            >
          </button>
          }
        </div>
      </div>

      <!-- Parking Status -->
      <div
        class="bg-white rounded-lg border border-gray-200 px-3 py-2.5 shadow-sm flex flex-col min-w-[180px]"
      >
        <div class="flex items-center gap-1.5 mb-2">
          <div class="w-2 h-2 rounded-full bg-amber-500"></div>
          <span
            class="text-[11px] font-bold uppercase tracking-wide text-gray-700"
            >Parking Status</span
          >
        </div>
        <div class="flex flex-wrap gap-1.5 flex-1 content-start">
          @for (card of parkingStatusCards; track card; let i = $index) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-full pl-2 pr-1 py-[3px] text-[11px] font-medium bg-white border border-gray-200 shadow-sm transition-all cursor-pointer hover:shadow hover:-translate-y-px"
            [ngClass]="
              isParkingStatusActive(card)
                ? 'ring-2 ring-teal-500 ring-offset-1 shadow-md border-teal-400'
                : ''
            "
            (click)="handleParkingStatusCard(card)"
          >
            <span
              class="w-1.5 h-1.5 rounded-full shrink-0"
              [ngClass]="i === 0 ? 'bg-emerald-500' : 'bg-orange-500'"
            ></span>
            <span class="text-gray-700 whitespace-nowrap">{{
              card.label
            }}</span>
            <span
              class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold text-white"
              [ngClass]="i === 0 ? 'bg-emerald-500' : 'bg-orange-500'"
              >{{ card.value }}</span
            >
          </button>
          }
        </div>
      </div>

      <!-- Parking Location -->
      <div
        class="bg-white rounded-lg border border-gray-200 px-3 py-2.5 shadow-sm flex flex-col min-w-[260px]"
      >
        <div class="flex items-center gap-1.5 mb-2">
          <div class="w-2 h-2 rounded-full bg-rose-500"></div>
          <span
            class="text-[11px] font-bold uppercase tracking-wide text-gray-700"
            >Parking Location</span
          >
        </div>
        <div class="flex flex-wrap gap-1.5 flex-1 content-start">
          @for (card of parkingLocationCards; track card; let i = $index) {
          <button
            type="button"
            class="inline-flex items-center gap-1.5 rounded-full pl-2 pr-1 py-[3px] text-[11px] font-medium bg-white border border-gray-200 shadow-sm transition-all cursor-pointer hover:shadow hover:-translate-y-px"
            [ngClass]="
              isParkingLocationActive(card)
                ? 'ring-2 ring-teal-500 ring-offset-1 shadow-md border-teal-400'
                : ''
            "
            (click)="handleParkingLocationCard(card)"
          >
            <span
              class="w-1.5 h-1.5 rounded-full shrink-0"
              [ngClass]="
                i % 3 === 0
                  ? 'bg-sky-500'
                  : i % 3 === 1
                  ? 'bg-violet-500'
                  : 'bg-rose-500'
              "
            ></span>
            <span class="text-gray-700 whitespace-nowrap">{{
              card.label
            }}</span>
            <span
              class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold text-white"
              [ngClass]="
                i % 3 === 0
                  ? 'bg-sky-500'
                  : i % 3 === 1
                  ? 'bg-violet-500'
                  : 'bg-rose-500'
              "
              >{{ card.value }}</span
            >
          </button>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- vehicls cards section -->

  @if (crdsview) {
  <section class="ams-vehicle-section" id="vehicle-cards">
    <div class="ams-vehicle-toolbar">
      <div class="flex items-center gap-2">
        <div
          class="flex items-center justify-center"
          style="
            width: 28px;
            height: 28px;
            background: #f1f5f9;
            border-radius: 6px;
          "
        >
          <svg
            style="width: 14px; height: 14px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            ></path>
          </svg>
        </div>
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            color: #1e293b;
          "
          >Vehicle List</span
        >
      </div>
      <div class="ams-vehicle-actions">
        <input
          nz-input
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="onFilterSearchChange($event)"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Search vehicle / ward / ULB"
          class="ams-search-input"
        />
        <div class="ams-view-toggle">
          <button
            class="ams-view-btn"
            [class.ams-view-btn--active]="!switchValue"
            (click)="setView('cards')"
          >
            <i nz-icon nzType="appstore" nzTheme="outline"></i> Cards
          </button>
          <button
            class="ams-view-btn"
            [class.ams-view-btn--active]="switchValue"
            (click)="setView('table')"
          >
            <i nz-icon nzType="table" nzTheme="outline"></i> Table
          </button>
        </div>
        <button
          nz-button
          nzType="default"
          class="ams-export-btn ams-export-btn--excel"
          (click)="export()"
        >
          <i nz-icon nzType="file-excel" nzTheme="outline"></i> Excel
        </button>
        <button
          nz-button
          nzType="default"
          class="ams-export-btn ams-export-btn--pdf"
          (click)="createPdf()"
        >
          <i nz-icon nzType="file-pdf" nzTheme="outline"></i> Pdf
        </button>
      </div>
    </div>
    <div class="vehicle-layout mt-2">
      @if (vhcleslst; as filteredVehicles) {
      <div class="flex flex-col gap-3">
        <div
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-3 w-full"
        >
          @for (v of filteredVehicles; track v; let i = $index) {
          <article
            class="ams-vcard rounded-lg bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer w-full"
            tabindex="0"
            [class.selected-card]="selectedVehicle?.asrt_id === v.asrt_id"
            (click)="handleVehicleSelect(v)"
          >
            <!-- Top Row: Icon + Name + Ignition + Action Buttons -->
            <div
              class="flex items-center justify-between gap-2 p-2.5 border-b border-gray-100"
              style="padding-bottom: 0px"
            >
              <div class="flex items-center gap-2 min-w-0 flex-1">
                <div
                  class="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center flex-shrink-0"
                >
                  <img
                    [src]="
                      '../../../assets/images/markers/mapIcons/' +
                      v.icon_pathr +
                      '.png'
                    "
                    alt="Vehicle icon"
                    class="w-5 h-5 object-contain"
                  />
                </div>
                <div class="min-w-0">
                  <div class="flex items-center gap-1 flex-wrap">
                    <p
                      class="text-sm font-bold text-gray-900 m-0 truncate"
                      [class.vehicle-number-highlight]="
                        selectedVehicle?.asrt_id === v.asrt_id
                      "
                    >
                      {{ v.asrt_nm }}
                    </p>
                    @if (v.asrt_ownr_id == 1) {
                    <span
                      class="px-1 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                      >Own vehicle</span
                    >
                    } @if (v.asrt_ownr_id == 2) {
                    <span
                      class="px-1 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                      >Hired vehicle</span
                    >
                    }
                  </div>
                  <div
                    class="px-1.5 py-0.5 text-[11px] text-gray-500 font-medium"
                  >
                    {{ v.dev_imei_nu || "NA" }}
                  </div>
                </div>
              </div>
              <!-- Status Icons + Action Buttons -->
              <div class="flex items-center gap-1.5 flex-shrink-0">
                <!-- <span *ngIf="v.sgnl_strngth_ct !== undefined">
                          <img src="assets/images/markers/mapIcons/m/sgnl_{{v.sgnl_strngth_ct}}.png"
                            alt="Signal" style="height: 16px; width: 16px; display: inline-block;" />
                          </span> -->
                @if (v.igntn_in !== undefined) {
                <span>
                  <img
                    src="assets/images/markers/mapIcons/m/igntn_{{
                      v.igntn_in
                    }}.png"
                    alt="Ignition"
                    style="height: 22px; width: 22px; display: inline-block"
                  />
                </span>
                }
                <!-- <span *ngIf="v.dev_imei_nu !== undefined" style="margin-right: 8px;">
                            <img src="assets/images/markers/mapIcons/m/chrg_1.png"
                              alt="Charge" style="height: 16px; width: 16px; display: inline-block;" />
                            </span> -->
                <!-- <span *ngIf="v.dev_imei_nu== undefined" style="margin-right: 8px;">
                            <img src="assets/images/markers/mapIcons/m/chrg_0.png"
                              alt="Charge" style="height: 16px; width: 16px; display: inline-block;" />
                            </span> -->
                <!-- <span *ngIf="v.spd_ct !== undefined && v.diffTimeInMin !== undefined"
                            [ngClass]="(v.spd_ct > 0 && v.diffTimeInMin < 5) ? 'greenCls' : (v.spd_ct >= 0 && v.diffTimeInMin <= 5) ? 'blueCls' : (v.spd_ct >= 0 && v.diffTimeInMin >= 5 && v.diffTimeInMin < 15) ? 'yellowCls' : 'redCls'"
                          style="height: 12px; width: 12px; display: inline-block; border-radius: 50%;"></span> -->
                <!-- View (eye) — opens the <app-vehicle-slider> drawer at the top of
                          this template (controlled by visibleVhclSldr). Previously routed
                          to /vehicle-dashboard which navigated away from this page;
                          switched to the in-page drawer per user spec. handleVehicleSelect
                          still runs first so [vechile]="selectedVehicle" on the drawer
                          has the correct row bound. -->
                <button
                  type="button"
                  class="w-8 h-8 flex items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                  (click)="handleVehicleSelect(v, $event); resumeSlider()"
                >
                  <svg
                    class="w-4.5 h-4.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                </button>
                <!-- Assign Driver Button (commented out) -->
                <!-- <button type="button"
                            class="w-8 h-8 flex items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                            (click)="handleVehicleSelect(v, $event); drvrasgndtls(v)">
                            <svg class="w-4.5 h-4.5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.25a7.5 7.5 0 0115 0" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M18.75 9.75v6M21 12h-4.5" />
                              </svg>
                            </button> -->
                <!-- Ward (home) icon — opens the ward-assignment form (UPDATE action).
                            Gated on updt_in so read-only users don't see it. -->
                @if (wrdlst && wrdlst.length>0 && USER_PERMISSIONS.updt_in == 1)
                {
                <button
                  type="button"
                  class="w-8 h-8 flex items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                  (click)="handleVehicleSelect(v, $event); openwardlstfrm(v)"
                >
                  <svg
                    class="w-4.5 h-4.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3 9.75l9-7.5 9 7.5M4.5 10.5v9.75A1.5 1.5 0 006 21.75h12a1.5 1.5 0 001.5-1.5V10.5"
                    />
                  </svg>
                </button>
                }
                <!-- Edit (pencil) icon — opens the vehicle-details edit form (UPDATE
                              action). Gated on updt_in; View (eye) button above stays visible
                              for every user with slct_in per the RBAC spec. -->
                @if (USER_PERMISSIONS.updt_in == 1) {
                <button
                  type="button"
                  class="w-8 h-8 flex items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                  (click)="handleVehicleSelect(v, $event); openvhcldtlsfrm(v)"
                >
                  <svg
                    class="w-4.5 h-4.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.862 4.487l1.688-1.688a1.875 1.875 0 112.652 2.652L10.5 16.15l-3 1 1-3 10.362-10.363z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 8.25l-2.25-2.25"
                    />
                  </svg>
                </button>
                }
              </div>
            </div>
            <!-- Body: Info Rows (compact) -->
            <div class="px-2.5 py-2 space-y-1 text-xs flex-1">
              <!-- Meta Info Tags -->
              <div class="flex flex-wrap items-center gap-1 pt-1">
                <!-- <span class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium">{{v.dev_imei_nu || 'NA'}}</span> -->
                <span
                  class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium"
                  >{{ v.tnt_nm || "NA" }}</span
                >
                <span
                  class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium"
                  >{{ v.asrt_ctgry_nm }}</span
                >
                <span
                  class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium"
                  >{{ v.asrt_grp_nm }}</span
                >
              </div>
              <div class="flex items-center justify-between">
                <span class="text-gray-500 font-medium uppercase tracking-wide"
                  >Driver:</span
                >
                <div
                  class="flex items-center gap-1.5 text-gray-800 font-semibold"
                >
                  <span>{{ v.crw_nm || "NA" }}</span>
                  <span
                    class="flex items-center gap-0.5 text-gray-400 font-normal text-[11px]"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 8.25c0 6.213 5.037 11.25 11.25 11.25.914 0 1.801-.114 2.653-.329a1.5 1.5 0 00.987-.94l.563-1.688a1.5 1.5 0 00-.342-1.492l-1.37-1.37a1.5 1.5 0 00-1.586-.355l-.986.33a10.05 10.05 0 01-4.21-4.21l.33-.986a1.5 1.5 0 00-.355-1.586l-1.37-1.37a1.5 1.5 0 00-1.492-.342l-1.688.563a1.5 1.5 0 00-.94.987 10.58 10.58 0 00-.329 2.652z"
                      />
                    </svg>
                    {{ v.crw_ph || "NA" }}
                  </span>
                </div>
              </div>
              <div class="flex items-center justify-between">
                <span class="text-gray-500 font-medium uppercase tracking-wide"
                  >Odometer:</span
                >
                <span class="text-gray-800 font-semibold"
                  >{{ v.odmtr_ct === null ? 0 : v.odmtr_ct }} kms</span
                >
              </div>
              <div class="flex items-center justify-between">
                <span class="text-gray-500 font-medium uppercase tracking-wide"
                  >Data last received:</span
                >
                <span class="text-gray-800 font-semibold">{{
                  v.data_received_ts | date : "short"
                }}</span>
              </div>
              <div class="flex items-center gap-1 text-gray-500 pt-0.5">
                <svg
                  class="w-3.5 h-3.5 text-gray-400 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10.5 6l-7 6 7 6M13.5 6l7 6-7 6"
                  />
                </svg>
                <span class="text-[11px]"
                  >{{ v.startFence || "Start" }} →
                  {{ v.endFence || "End" }}</span
                >
              </div>
              <!-- Meta Info Tags -->
              <!-- <div class="flex flex-wrap items-center gap-1 pt-1">
                                <span class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium">{{v.dev_imei_nu || 'NA'}}</span>
                                <span class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium">{{v.tnt_nm || 'NA'}}</span>
                                <span class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium">{{v.asrt_ctgry_nm}}</span>
                                <span class="px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-500 font-medium">{{v.asrt_grp_nm}}</span>
                              </div> -->
            </div>
          </article>
          }
        </div>
        @if (!showLdr) {
        <div
          class="vehicle-pagination flex flex-wrap justify-center items-center gap-2"
        >
          <button
            type="button"
            class="px-3 py-1 rounded-full border border-slate-200 text-sm font-medium text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onPageChange(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            Prev
          </button>
          @for (p of getPageNumbers(); track p) { @if (p === -1) {
          <span class="px-2 text-slate-400">...</span>
          } @if (p !== -1) {
          <button
            type="button"
            class="px-3 py-1 rounded-full border border-slate-200 text-sm font-medium hover:bg-blue-50"
            [ngClass]="
              currentPage === p
                ? 'bg-blue-600 text-white border-blue-600'
                : 'text-slate-600'
            "
            (click)="onPageChange(p)"
          >
            {{ p }}
          </button>
          } }
          <button
            type="button"
            class="px-3 py-1 rounded-full border border-slate-200 text-sm font-medium text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onPageChange(currentPage + 1)"
            [disabled]="currentPage >= getTotalPages()"
          >
            Next
          </button>
          <span class="text-xs text-slate-500 ml-2"
            >{{ totalVehicles }} vehicles</span
          >
        </div>
        } @else {
        <div
          class="vehicle-pagination flex flex-wrap justify-center items-center gap-2 pagination-loading"
        >
          <nz-spin nzSimple></nz-spin>
          <span>Loading vehicles...</span>
        </div>
        }
      </div>
      }
    </div>
    @if (drvrasgn) {
    <nz-modal
      nzTitle="Assign Driver"
      nzClosable="true"
      [(nzVisible)]="drvrasgn"
      nzMaskClosable="false"
      [nzWidth]="420"
      (nzOnCancel)="closeDriverModal()"
    >
      <ng-container *nzModalContent>
        <div class="space-y-3 p-1">
          <div class="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
            <p class="text-[11px] uppercase tracking-wide text-slate-500">
              Vehicle Number
            </p>
            <p class="text-base font-semibold text-slate-900">
              {{ vhclenumbr }}
            </p>
          </div>
          <form nz-form class="space-y-3">
            <div nz-row [nzGutter]="8">
              <div nz-col nzSpan="24">
                <nz-form-label>Select From Date</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <nz-date-picker
                      class="w-full"
                      [(ngModel)]="dte"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onDateChng()"
                      nzFormat="dd-MM-yyyy"
                    ></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Select Trip no</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <nz-select
                      nzShowSearch
                      nzAllowClear
                      nzPlaceHolder="Select trip"
                      [(ngModel)]="trp_nu"
                      [ngModelOptions]="{ standalone: true }"
                      nzMode="multiple"
                    >
                      @for (t of trpslst; track t) {
                      <nz-option
                        [nzLabel]="t.trp_sqnc_nu"
                        [nzValue]="t.trp_rn_id"
                      ></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Select Driver</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <nz-select
                      nzShowSearch
                      nzAllowClear
                      nzPlaceHolder="Select driver"
                      [(ngModel)]="crw_id"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      @for (v of drvrslst; track v) {
                      <nz-option
                        [nzLabel]="v.crw_nm"
                        [nzValue]="v.crw_id"
                      ></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>
        </div>
      </ng-container>
      <ng-container *nzModalFooter>
        <button nz-button nzType="default" (click)="closeDriverModal()">
          Cancel
        </button>
        <button nz-button nzType="primary" (click)="saveasgnmnt()">
          Submit
        </button>
      </ng-container>
    </nz-modal>
    } @if (vhcledtls) {
    <nz-drawer
      [nzBodyStyle]="{ overflow: 'auto' }"
      [nzMaskClosable]="false"
      [nzWidth]="520"
      [nzVisible]="visible"
      nzTitle="Edit Vehicle Details"
      (nzOnClose)="closedrvrlst()"
    >
      <ng-container *nzDrawerContent>
        <form nz-form [formGroup]="vhcldtlsform" class="vehicle-edit-form">
          <div class="vehicle-edit-form__grid">
            <div class="vehicle-edit-form__field">
              <nz-form-label>Vehicle Number</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="veh_nu"
                    placeholder="Vehicle Number"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="vehicle-edit-form__field">
              <nz-form-label>Vehicle Group</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Group"
                    formControlName="veh_grp"
                    (ngModelChange)="onvehGrpSelect($event)"
                  >
                    @for (v of vhcleGrp; track v) {
                    <nz-option
                      [nzLabel]="v.asrt_grp_nm"
                      [nzValue]="v.asrt_grp_id"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="vehicle-edit-form__field">
              <nz-form-label>Vehicle Category</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Category"
                    formControlName="veh_ctgry"
                  >
                    @for (v of vehctgryLst; track v) {
                    <nz-option
                      [nzLabel]="v.asrt_ctgry_nm"
                      [nzValue]="v.asrt_ctgry_id"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="vehicle-edit-form__field">
              <nz-form-label>Status</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Status"
                    formControlName="veh_sts"
                    (ngModelChange)="onstatusChange($event)"
                  >
                    @for (v of vehicleSts; track v) {
                    <nz-option
                      [nzLabel]="v.asrt_sts_nm"
                      [nzValue]="v.asrt_sts_id"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="vehicle-edit-form__section">
            <p class="vehicle-edit-form__section-title">
              Trip & Performance thresholds
            </p>
            <div class="vehicle-edit-form__two-col">
              <div class="vehicle-edit-form__field">
                <nz-form-label>Minimum Trips</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Alerts can be generated if the vehicle doesn’t operate these
                  many trips before reaching back to its home location.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="Trips"
                      formControlName="veh_trps"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="vehicle-edit-form__field">
                <nz-form-label>Speed limit (Km/hr)</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Use this to trigger overspeed notifications in daily reports.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="Speed"
                      formControlName="veh_spd"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="vehicle-edit-form__field">
                <nz-form-label>Distance</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Maximum distance the vehicle should travel in a day.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="Distance"
                      formControlName="veh_dstnce"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="vehicle-edit-form__field">
                <nz-form-label>Stoppage Time</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Flag unauthorised stoppages that exceed this duration.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="UnAuthorised Stoppage Time"
                      formControlName="veh_stpg_tm"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="vehicle-edit-form__field">
                <nz-form-label>Milage (Km/L)</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Used for fuel efficiency benchmarking.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="Milage in Km/liter"
                      formControlName="veh_mlge"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
          <div class="vehicle-edit-form__section">
            <p class="vehicle-edit-form__section-title">
              Home location & alerts
            </p>
            <div class="vehicle-edit-form__field">
              <nz-form-label>Home Location</nz-form-label>
              <p class="vehicle-edit-form__hint">
                This is the location where the vehicle stays and starts its
                first trip every day (for example: Vehicle Yard).
              </p>
              <nz-form-item>
                <nz-form-control>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    nzPlaceHolder="Select Home Location"
                    formControlName="hme_fnce_id"
                    (ngModelChange)="onstatusChange($event)"
                  >
                    @for (f of fncsLst; track f) {
                    <nz-option
                      [nzLabel]="f.fnce_nm"
                      [nzValue]="f.fnce_id"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="vehicle-edit-form__two-col">
              <div class="vehicle-edit-form__field">
                <nz-form-label>Start Time</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Time before which the vehicle must leave the home location for
                  collection.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <nz-time-picker
                      nzShowTime
                      formControlName="strt_tm"
                      [nzFormat]="timeFormat"
                    ></nz-time-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="vehicle-edit-form__field">
                <nz-form-label>Notify Interval (mins)</nz-form-label>
                <p class="vehicle-edit-form__hint">
                  Maximum delay from the start time for the vehicle to exit the
                  yard.
                </p>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      placeholder="Enter Time Interval"
                      formControlName="ntfy_intrvl_tm"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </form>
        <div class="vehicle-edit-form__actions">
          <button nz-button nzType="default" nzDanger (click)="closedrvrlst()">
            Cancel
          </button>
          @if (vhcldtlsform.status == 'VALID') {
          <button
            nz-button
            nzType="primary"
            (click)="updateVehicleData()"
            class="sbmtbtn"
          >
            Submit
          </button>
          }
        </div>
      </ng-container>
    </nz-drawer>
    } @if (warddtls) {
    <nz-modal
      nzTitle="Assign Ward"
      nzClosable="true"
      [(nzVisible)]="warddtls"
      nzMaskClosable="false"
      [nzWidth]="420"
      (nzOnCancel)="closervrlst()"
    >
      <ng-container *nzModalContent>
        <form nz-form [formGroup]="warddtlsform" class="space-y-3 p-1">
          <div>
            <nz-form-label>Vehicle Number</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <input
                  nz-input
                  formControlName="veh_nu"
                  placeholder="Vehicle Number"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-label>Ward</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Ward"
                  formControlName="wrd_nm"
                >
                  @for (v of wrdlst; track v) {
                  <nz-option
                    [nzLabel]="v.wrd_nm"
                    [nzValue]="v.wrd_id"
                  ></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </form>
      </ng-container>
      <ng-container *nzModalFooter>
        <button nz-button nzType="default" (click)="closervrlst()">
          Cancel
        </button>
        @if (warddtlsform.status == 'VALID') {
        <button
          nz-button
          nzType="primary"
          (click)="updateWardData()"
          class="sbmtbtn"
        >
          Submit
        </button>
        }
      </ng-container>
    </nz-modal>
    }
  </section>
  }

  <!-- vehicle list table section -->
  @if (tblview) {
  <section class="dashboard-section table-section">
    <div class="section-top-row pb-4">
      <div>
        <p class="section-pill">Vehicle list</p>
      </div>
      <div class="view-actions">
        <div class="view-toggle">
          <button
            class="view-toggle__btn"
            [class.active]="!switchValue"
            (click)="setView('cards')"
          >
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
            Cards
          </button>
          <button
            class="view-toggle__btn"
            [class.active]="switchValue"
            (click)="setView('table')"
          >
            <i nz-icon nzType="table" nzTheme="outline"></i>
            Table
          </button>
        </div>
        <!-- <button nz-button nzType="default"
                    class="flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 transition hover:border-emerald-300"
                    (click)="export()">
                    <i nz-icon nzType="file-excel" nzTheme="outline"></i> Excel
                  </button>
                  <button nz-button nzType="default"
                    class="flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-4 py-2 text-sm font-semibold text-rose-600 transition hover:border-rose-300"
                    (click)="createPdf()">
                    <i nz-icon nzType="file-pdf" nzTheme="outline"></i> Pdf
                  </button> -->
      </div>
    </div>
    <app-data-grid
      class="rounded-2xl border border-slate-100 p-4"
      style="width: 100%"
      (cellClick)="onCellClick($event)"
      [dataSource]="filteredVehicles"
      [legacyColumns]="vhclslstcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="Vehicles List Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
    </app-data-grid>
  </section>
  }
</div>
<!-- </div> -->
